import React from 'react';
const Chase = () => {
  return (
    <svg
      fill='#000000'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 28 28'
      width='40px'
      height='40px'
    >
      <path d='M21 10h-4.5c-.276 0-.5.224-.5.5v10.154c0 .305.373.454.583.232l5.141-5.416c.176-.186.275-.432.275-.688L22 11C22 10.448 21.552 10 21 10zM14 21v-4.5c0-.276-.224-.5-.5-.5H3.346c-.305 0-.454.373-.232.583l5.416 5.141c.186.176.432.275.688.275L13 22C13.552 22 14 21.552 14 21zM3 14h4.5C7.776 14 8 13.776 8 13.5V3.346c0-.305-.373-.454-.583-.232L2.277 8.53C2.101 8.716 2.002 8.962 2.002 9.218L2 13C2 13.552 2.448 14 3 14zM10.5 8h10.154c.305 0 .454-.373.232-.583L15.47 2.277c-.186-.176-.432-.275-.688-.275L11 2c-.552 0-1 .448-1 1v4.5C10 7.776 10.224 8 10.5 8z' />
    </svg>
  );
};
export default Chase;
